
import ListExperience from "../components/HistoryExperience";

const Experience = () => {
  return (
  <div className="min-h-screen bg-white">
    <div className="bg-[#55ad6d] min-h-screen p-20 max-w-6xl mx-auto">
      <div className="flex flex-rows gap-6 items-start justify-center mt-5">
        <ListExperience></ListExperience>
      </div>
    </div>
  </div>)
};

export default Experience;
